import React, { useState } from 'react'
import { CheckCircle, RadioButtonUnchecked } from '@material-ui/icons'
import PropTypes from 'prop-types'

import useCurrentUserProp from 'hooks/useCurrentUserProp'
import { stopTithing, startTithing } from 'actions/campaigns'
import { useDispatch } from 'react-redux'
import ActionChip from 'components/JarCard/ActionChip'

const TitheChip = ({ jarId }) => {
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()
  const userId = useCurrentUserProp('id')
  const userIsTithing = useCurrentUserProp('tithedJars').includes(jarId)

  function handleClick(actionToDispatch) {
    setLoading(true)
    dispatch(actionToDispatch(userId, jarId)).then(() => {
      setLoading(false)
    })
  }

  return (
    userIsTithing ? (
      <ActionChip
        labelText='Tithing enabled'
        handleClick={() => handleClick(stopTithing)}
        Icon={CheckCircle}
        loading={loading}
      />
    ) : (
      <ActionChip
        labelText='Enable tithing'
        handleClick={() => handleClick(startTithing)}
        Icon={RadioButtonUnchecked}
        loading={loading}
      />
    )
  )
}

TitheChip.propTypes = {
  jarId: PropTypes.string.isRequired
}

export default TitheChip
